import { colors, fonts } from '@grupoboticario/flora-tokens/belezanaweb/web/ds'

export const belezanaweb = {
  colors,
  fonts,
}
